
import {
    LoginRegisterHeaderStyles, LoginRegisterTabButtonStyles,
} from './styles/LoginRegisterHeader'

import Logo from 'components/Logo'
import React from 'react'
import {SelectedItem} from 'components/Register/types'
import {navigation} from 'navigation'
import router from 'navigation/router'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const LoginRegisterHeaderStyled = styled('div', LoginRegisterHeaderStyles)
const LoginRegisterTabButtonStyled = styled('button', LoginRegisterTabButtonStyles)

const LoginRegisterHeader = () => {
    const [selected, setSelected] = React.useState(SelectedItem.Register)
    const {t} = useTranslation()

    const loadRegisterView = () => navigation.push('Register')

    const loadLoginView = (): void => {
        navigation.push('Login')
    }

    React.useEffect(() => {
        const [, url] = window.location.hash.split('#')

        if (router.match(url)?.name === 'Login') {
            setSelected(SelectedItem.Login)
        } else {
            setSelected(SelectedItem.Register)
        }
    }, [])

    return (
        <LoginRegisterHeaderStyled>
            <p className='text-center'>
                <Logo />
            </p>
            <div className='loginOrRegisterContainer'>
                <LoginRegisterTabButtonStyled
                    onClick={(): void => loadLoginView()}
                    onFocus={(): void => setSelected(SelectedItem.Login)}
                    selected={selected === SelectedItem.Login}
                    type='button'
                >{t('Sign in')}
                </LoginRegisterTabButtonStyled>
                <LoginRegisterTabButtonStyled
                    autoFocus={true}
                    onClick={(): void => loadRegisterView()}
                    onFocus={(): void => setSelected(SelectedItem.Register)}
                    selected={selected === SelectedItem.Register}
                    type='button'
                >{t('Create account')}
                </LoginRegisterTabButtonStyled>
            </div>
        </LoginRegisterHeaderStyled>)
}

export default LoginRegisterHeader
